/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : userDetailsReducer.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import customConsole from "../../config/customConsole";
import actionType from "../actionTypes";

const initialState = {
  error: false,
  msg: "",
  userDetailsList: {},
};

const userDetailsReducer = (state = initialState, action) => {
  customConsole(action);
  switch (action.type) {
    case actionType.GET_USERS_DETAILS_LIST:
      return {
        ...state,
        error: action.payload.error,
        msg: action.payload.msg,
        userDetailsList: action.payload.error ? [] : action.payload.data,
      };

    default:
      return state;
  }
};

export default userDetailsReducer;
